import {useQuery} from '@tanstack/react-query'
import {useEffect} from 'react'
import {QueryCacheKeys} from '../../QueryKey'
import {getKey} from '../../../apis/user/getKey'
import {getWalletTransactions} from '../../../apis/wallet/getWalletTransaction'

const useQueryWalletTransactionsDetail = (userId?: string, current_page: number = 1) => {
    const {data, refetch, isLoading} = useQuery({
        queryKey: QueryCacheKeys.wallet.getWalletTransactions(userId, current_page),
        queryFn: async () => {
            const {data, pageInfo} = await getWalletTransactions(userId, current_page)
            return {data, pageInfo}
        },
    })

    return {data, refetch, isLoading}
}

export default useQueryWalletTransactionsDetail
